import { Fragment } from 'react'

import { ContentPage_content_ImageContent } from 'globalTypes'

import Paragraph from 'Root/App/Paragraph'
import PreTitle from 'Root/App/PreTitle'
import List from 'Root/App/Tag/List'
import Title from 'Root/App/Title'
import BottomContent from 'Root/Pages/Content/Component/BottomContent'

import Carousel from './Carousel'
import SingleImage from './SingleImage'

interface Props {
  content: ContentPage_content_ImageContent
}

const DefaultStatus = ({ content }: Props) => {
  return (
    <Fragment>
      {'carousel' === content.imageSubtype ? (
        <Carousel content={content} />
      ) : (
        <Fragment>
          <SingleImage content={content} />
          <div className="flex flex-col gap-y-3 p-6">
            <div className="flex flex-col gap-y-3">
              <PreTitle className="-m-1">{content.label}</PreTitle>
              <Title maxRows={3}>{content.title}</Title>
              <Paragraph>{content.description}</Paragraph>
            </div>
            <List tags={content.tags} />
            <BottomContent content={content} />
          </div>
        </Fragment>
      )}
    </Fragment>
  )
}

export default DefaultStatus
